import api from 'api'

export type ReprocessCompumaticPunchesParams = {
  punchIds: number[]
}

export type ReprocessCompumaticPunchesResponse = {
  updatedCount: number
}

export async function reprocessCompumaticPunches(
  params: ReprocessCompumaticPunchesParams
): Promise<ReprocessCompumaticPunchesResponse> {
  const result = await api.post<ReprocessCompumaticPunchesResponse>(
    '/admin/time_clock/compumatic_punches/reprocess',
    params
  )
  return result.data
}
